module.exports = __webpack_public_path__ + "static/media/Snapchat.268e5bc9.svg";